var map = {
	"./_black_green.styl": 1274,
	"./_black_grey.styl": 1275,
	"./_black_red.styl": 1276,
	"./_blue.styl": 1277,
	"./_default.styl": 1278,
	"./_grey_light.styl": 1279,
	"./_light_black.styl": 1280,
	"./_pink_light.styl": 1281,
	"./_purple_dark.styl": 1282
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1273;


//////////////////
// WEBPACK FOOTER
// ../colorscheme !/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[sha512:hash:base64:7].css!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-colorsheme-res-resolver!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/stylus-loader ^\.\/_.*\.styl$
// module id = 1273
// module chunks = 4